<mat-sidenav-container class="flex-nav-printable">
    <mat-sidenav class="mat-elevation-z4 no-print" [mode]="(isHandset$ | async) ? 'over' : 'side'" opened>
        <div fxLayout="column">
            <div
                fxLayout="row"
                [ngClass]="{ 'sidenav-local': isLocal, 'sidenav-test': isTest, 'sidenav-prod': isProd }"
                fxFlex="1 0 auto"></div>
            <div class="sidenav-name-version-number">
                <b>T I M E S H E E T S</b>
                <small
                    class="padding-left sidenav-version-number"
                    matTooltip="What's new in TimeSheets?"
                    (click)="showWhatsNew()">
                    <span>version {{ frontEndVersion }}</span>
                    <i class="material-icons">help</i>
                </small>
            </div>
            <div class="import-status">
                <ng-container *ngIf="currentImport$ | async as currentImport">
                    <ng-container *ngIf="this.admin">
                        <div
                            matTooltip="import currently running"
                            [matTooltipDisabled]="!isBackfillButtonDisabled(currentImport.status)">
                            <button
                                [disabled]="isBackfillButtonDisabled(currentImport.status)"
                                mat-stroked-button
                                color="primary"
                                matTooltip="start Jira backfill"
                                (click)="showImportDialog()">
                                <i class="material-icons">upload</i>
                                Backfill
                            </button>
                        </div>
                    </ng-container>

                    <ng-container [ngSwitch]="currentImport.status">
                        <ng-container *ngSwitchCase="'PROCESSING'">
                            <small class="padding-left import-running" matTooltip="import currently running">
                                <i class="material-icons">download</i>
                                <span>{{ currentImport.start.format('DD-MM-YYYY HH:mm:ss') }}</span>
                                <i class="material-icons">sync</i>
                            </small>
                        </ng-container>

                        <ng-container *ngSwitchCase="'FAILED'">
                            <small class="padding-left import-failed" matTooltip="last import failed">
                                <i class="material-icons">download</i>
                                <span>{{ currentImport.end.format('DD-MM-YYYY HH:mm:ss') }}</span>
                                <i class="material-icons">close</i>
                            </small>
                        </ng-container>

                        <ng-container *ngSwitchCase="'SUCCESS'">
                            <small class="padding-left import-success" matTooltip="imported successfully">
                                <i class="material-icons">download</i>
                                <span>{{ currentImport.end.format('DD-MM-YYYY HH:mm:ss') }}</span>
                                <i class="material-icons">check</i>
                            </small>
                        </ng-container>
                    </ng-container>
                </ng-container>
            </div>

            <mat-divider class="divider"></mat-divider>

            <div class="sidenav-authenticated-user">
                <button
                    *ngIf="currentUser$ | async as currentUser"
                    mat-stroked-button
                    color="accent"
                    matTooltip="Show profile"
                    (click)="showProfilePreferences()">
                    <i class="material-icons">account_circle</i>
                    <span class="name">{{ currentUser.givenName }} {{ currentUser.familyName }}</span>
                </button>
                <button mat-icon-button color="primary" matTooltip="Log out" (click)="logout()">
                    <i class="material-icons">exit_to_app</i>
                </button>
            </div>

            <mat-divider class="divider"></mat-divider>
            <ng-container *ngIf="this.admin">
                <ppw-employee-filter></ppw-employee-filter>
                <mat-divider class="divider"></mat-divider>
            </ng-container>
        </div>
        <ppw-hierarch-menu *ngIf="menuItems !== undefined" [menuItems]="menuItems"></ppw-hierarch-menu>
    </mat-sidenav>
    <mat-sidenav-content class="start-content">
        <router-outlet></router-outlet>
    </mat-sidenav-content>
</mat-sidenav-container>
